/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Save_TitleInputs */



/**
* | output |
* | --- |
* | "Save Audio Description Export Preset" |
*
* @param {Audio_Description_Export_Preset_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_save_title = /** @type {((inputs?: Audio_Description_Export_Preset_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer le préréglage d'exportation de description audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibung speichern Exportieren Voreinstellung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva preimpostazione di esportazione della descrizione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить аудиоописание Экспорт предустановки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar preajuste de exportación de descripción de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存音频描述导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ説明エクスポートプリセットを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण निर्यात प्रीसेट सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar descrição de áudio Exportar predefinição")
	return /** @type {LocalizedString} */ ("Save Audio Description Export Preset")
});